import { Loading } from '@chiroup/components/Loading';
import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

const Advice = lazy(() => import('./advice/Advice'));
const Conditions = lazy(() => import('./conditions/Conditions'));
const Evaluations = lazy(() => import('./evaluations/Evaluations'));
const Exercises = lazy(() => import('./exercises/Exercises'));
const Treatments = lazy(() => import('./treatments/Treatments'));
const Supplements = lazy(() => import('./supplements/Supplements'));
const Modalities = lazy(() => import('./modalities/Modalities'));

const ClinicalSkills = () => {
  return (
    <Suspense fallback={<Loading size={5} />}>
      <Routes>
        <Route path={`/advice/*`} element={<Advice />} />
        <Route path={`/supplements/*`} element={<Supplements />} />
        <Route path={`/conditions/*`} element={<Conditions />} />
        <Route path={`/evaluations/*`} element={<Evaluations />} />
        <Route path={`/modality/*`} element={<Modalities />} />
        <Route path={`/treatments/*`} element={<Treatments type="Clinical" />} />
        <Route path={`/exercises/*`} element={<Exercises />} />
        <Route path={`/common-treatments/*`} element={<Treatments type="Common" />} />
        <Route path="*" element={<span>no match</span>} />
      </Routes>
    </Suspense>
  );
};

export default ClinicalSkills;
